import {
  API_STAGE_BASE,
  API_PROD_BASE,
  PG_API_ENDPOINTS,
  PG_API_PROD_BASE,
  CUSTOMER_EDGE_APIS,
  API_EDGE_STAGE_BASE,
  PG_API_EDGE_STAGE_BASE,
  API_ENDPOINTS,
} from '@/constants';

const customerRouteRegex = /(?:\/)?customers?\/\d+/;
/* eslint-disable @typescript-eslint/naming-convention */
declare const __STAGE__: string;
const isProd = __STAGE__ === 'production';

export const getApiURL = (path: string, queryParam: Record<string, string>): string => {
  let API_HOST = isProd ? API_PROD_BASE : API_STAGE_BASE;

  // For APIs going via edge route on stage environment API endpoint includes ext
  if (
    (CUSTOMER_EDGE_APIS.includes(path) || customerRouteRegex.test(path)) &&
    __STAGE__ !== 'production'
  ) {
    API_HOST = API_EDGE_STAGE_BASE;
  }
  // For OTP Create and Verify we will be hitting PG API so need to specify the base url differently
  if (PG_API_ENDPOINTS.includes(path)) {
    API_HOST = isProd ? PG_API_PROD_BASE : PG_API_EDGE_STAGE_BASE;
  }

  const API_VERSION = path === API_ENDPOINTS.OTP_VERIFY ? '' : '/v1';

  const baseURL = `https://${API_HOST}${API_VERSION}/`;
  const url = new URL(path, baseURL);

  Object.keys(queryParam).forEach((key) => url.searchParams.append(key, String(queryParam[key])));

  return url.toString();
};
/**
 * Helper function to get query param from url
 */
export function getQueryParam(query: string): string | null {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(query);
}
